import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { _NumberField } from "../form";
import { TNumberFieldProps } from "../form/NumberField";

const useStyles = makeStyles({
    btn: {
        textAlign: "center"
    }
});

export const _IncrementField: React.FC<TNumberFieldProps> = props => {
    const classes = useStyles();
    const { Id, Value, OnChange } = props;

    const onClickDecrementBtn = () => {
        OnChange(Id, String(Number(Value) - 1));
    };
    const onClickIncrementBtn = () => {
        OnChange(Id, String(Number(Value) + 1));
    };

    return (
        <Grid container spacing={1} alignItems="center">
            <Grid item xs={2} className={classes.btn}>
                <IconButton aria-label="delete" size="small" color="secondary" onClick={onClickDecrementBtn}>
                    <RemoveIcon />
                </IconButton>
            </Grid>
            <Grid item xs={8}>
                <_NumberField {...props} />
            </Grid>
            <Grid item xs={2} className={classes.btn}>
                <IconButton aria-label="delete" size="small" color="secondary" onClick={onClickIncrementBtn}>
                    <AddIcon />
                </IconButton>
            </Grid>
        </Grid>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/form/IncrementField.tsx